import dayjs from 'dayjs';
import moment from 'moment-timezone';

const marketTimeZones = {
  gt: 'America/Guatemala',
  sv: 'America/El_Salvador',
  hn: 'America/Tegucigalpa',
  ni: 'America/Managua',
};
const WALL_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS';

export const getEventTimeZone = (country = process.env.REACT_APP_COUNTRY) =>
  marketTimeZones[country] || marketTimeZones.gt;

// Pickers represent the displayed wall time. Convert it using the market, never
// the browser's offset, so remote administrators edit the same event schedule.
export const toEventISOString = (value, timeZone = getEventTimeZone()) =>
  moment.tz(value.format(WALL_TIME_FORMAT), timeZone).toISOString();

export const toEventPickerDate = (value, timeZone = getEventTimeZone()) =>
  dayjs(moment(value).tz(timeZone).format(WALL_TIME_FORMAT));

export const formatEventDate = (value, format, timeZone = getEventTimeZone()) =>
  moment(value).tz(timeZone).format(format);

export const getEventReportRange = (range, timeZone = getEventTimeZone()) => ({
  startAt: moment.tz(range[0].format('YYYY-MM-DD'), timeZone).startOf('day').toISOString(),
  endAt: moment.tz(range[1].format('YYYY-MM-DD'), timeZone).endOf('day').toISOString(),
});
